"use strict";

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    if (e.target.closest(".omd-cta-block")) {
      if (e.target.closest(".cta-register")) {
        e.target.closest(".omd-cta-block").classList.add("hidden");
      }
      var ctasParent = e.target.parentNode.parentNode;
      if (ctasParent.nextElementSibling.classList.contains("omd-simple-register-form-container")) {
        ctasParent.nextElementSibling.classList.add("active");
      }
    }
    if (e.target.closest(".omd-register-form-cancel")) {
      e.target.parentNode.parentNode.parentNode.classList.remove("active");
      e.target.parentNode.parentNode.parentNode.previousElementSibling.classList.remove("hidden");
    }
  });
});